import { observer } from "mobx-react";
import React from "react";
import { GetAChannel } from "../../stores/GetAChannel";
import { Group, Button, Text, Stack } from "@mantine/core";

const NetworkSelector: React.FC<{ getAChannel: GetAChannel }> = observer(
  ({ getAChannel }) => {
    return (
      <>
        <Stack>
          {!getAChannel.userHasConfirmedIsConnected && (
            <Text>
              First thing: Choose your network. If you're not sure, probably
              choose "Mainnet".
            </Text>
          )}

          <Group>
            <Button
              size="lg"
              variant={
                getAChannel.selectedNetwork === "Mainnet" ? "filled" : "outline"
              }
              onClick={() => getAChannel.setSelectedNetwork("Mainnet")}
            >
              Mainnet
            </Button>
            <Button
              size="lg"
              variant={
                getAChannel.selectedNetwork === "MutinyNet"
                  ? "filled"
                  : "outline"
              }
              onClick={() => getAChannel.setSelectedNetwork("MutinyNet")}
            >
              MutinyNet
            </Button>
          </Group>
        </Stack>
      </>
    );
  }
);

export default NetworkSelector;
